/**
 * rc-hide-copies.js
 * Fixes the product count display on collection pages to exclude
 * copied products whose handles end in "-1".
 * Products are hidden via Liquid unless checks; this script corrects
 * the count numbers rendered by Shopify's facets/collection system.
 */
(function () {
  function fixProductCount() {
    const countData = document.getElementById('rc-copy-count');
    if (!countData) return;

    const hiddenCount = parseInt(countData.dataset.count || '0', 10);
    if (hiddenCount === 0) return;

    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const text = el.textContent.trim();
      // Match the first number in the string (the product count)
      const numMatch = text.match(/\d+/);
      if (numMatch) {
        const original = parseInt(numMatch[0], 10);
        const corrected = Math.max(0, original - hiddenCount);
        el.textContent = text.replace(numMatch[0], String(corrected));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductCount);
  } else {
    fixProductCount();
  }

  // Re-run after facet/filter Ajax reloads
  document.addEventListener('shopify:section:load', fixProductCount);
})();
